import type { FaireProductEntity } from "../../entity_types/product";

export const p_5qawrfjq5a: FaireProductEntity = {
  token: "p_5qawrfjq5a",
  type: "product",
  name: "*NEW* Coastal Waves - Handcrafted Artisan Soap Bar",
  brandName: "Spirit Glow Home & Body Essentials",
  imageUrl:
    "https://cdn.faire.com/fastly/aacd4e29a332b42371cce26a834da9dc34a3447495447a52a9fee1ad320400f2.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c8c83e0bf9f2ae9fd9c21d44dd915d47d02578eabf9413c016c19224fe1d7b0c.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
